import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function RelateRequestsReducer(
	state = initialState.relateRequests,
	action
) {
	switch (action.type) {
		case types.GET_RELATE_REQUESTS: {
			let relateRequests = action.response;
			return {...relateRequests};
		}
		case types.RESET_TASK_DOCUMENTS:
			return {};
		case types.RESET_RELATE_REQUESTS:
			return initialState.relateRequests;
		case types.CLEAR_RELATE_REQUESTS:
			let relateRequests = state;
			relateRequests.data = [];
			return {...relateRequests};
		case types.UPDATE_REQUEST_STATUS: {
			let newState = {...state};
			newState.data =
				state.data &&
				state.data.map((request) => {
					if (request.requestId == action.id)
						return {...request, updating: action.updating};
					else return request;
				});
			return newState;
		}
		case types.Add_RELATED_REQUEST: {
			let newState = {...state};
			newState.data =
				state.data &&
				state.data.map((request) => {
					if (request.requestId == action.meta.api.data.clientrequestid)
						return {...request, isAdded: !request.isAdded};
					else return request;
				});
			return newState;
		}
		default:
			return state;
	}
}
